var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendpadLoginLogo32C527Ca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 229.666,
    height: 40.607,
    viewBox: "0 0 229.666 40.607",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sendpad-logo",
    transform: "translate(-140 -82.731)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "send",
    transform: "translate(140 90.247)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20926",
    "data-name": "Group 20926",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20925",
    "data-name": "Group 20925"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44322",
    "data-name": "Path 44322",
    d: "M144.4,261.976a13.288,13.288,0,0,1-4.4-2.066l1.943-4.309a13.18,13.18,0,0,0,3.78,1.872,14.186,14.186,0,0,0,4.38.706,7,7,0,0,0,3.6-.724,2.187,2.187,0,0,0,1.166-1.925,1.841,1.841,0,0,0-.689-1.466,5.225,5.225,0,0,0-1.766-.936q-1.078-.353-2.914-.777a40.114,40.114,0,0,1-4.628-1.342,7.514,7.514,0,0,1-3.091-2.155,5.817,5.817,0,0,1-1.289-3.956,6.883,6.883,0,0,1,1.166-3.9,7.841,7.841,0,0,1,3.515-2.773,14.343,14.343,0,0,1,5.74-1.025,19.022,19.022,0,0,1,4.628.565,13.676,13.676,0,0,1,3.956,1.625l-1.766,4.345a13.794,13.794,0,0,0-6.853-1.943,6.427,6.427,0,0,0-3.55.777,2.372,2.372,0,0,0-1.148,2.049,2,2,0,0,0,1.325,1.89,20.771,20.771,0,0,0,4.045,1.219,40.438,40.438,0,0,1,4.628,1.342,7.67,7.67,0,0,1,3.091,2.12,5.685,5.685,0,0,1,1.289,3.921,6.753,6.753,0,0,1-1.183,3.868,7.955,7.955,0,0,1-3.55,2.773,14.479,14.479,0,0,1-5.758,1.024A20.224,20.224,0,0,1,144.4,261.976Z",
    transform: "translate(-140 -237.196)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44323",
    "data-name": "Path 44323",
    d: "M686.547,266.043v4.592H667.4V245.908h18.687V250.5h-13v5.369h11.481v4.451H673.088v5.723Z",
    transform: "translate(-641.739 -245.484)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44324",
    "data-name": "Path 44324",
    d: "M1196.649,245.908v24.727h-4.7l-12.328-15.013v15.013h-5.652V245.908h4.733L1191,260.921V245.908Z",
    transform: "translate(-1123.66 -245.484)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44325",
    "data-name": "Path 44325",
    d: "M1760.558,245.908h11.233a15.788,15.788,0,0,1,7.118,1.537,11.51,11.51,0,0,1,4.8,4.327,13.185,13.185,0,0,1,0,13,11.507,11.507,0,0,1-4.8,4.327,15.787,15.787,0,0,1-7.118,1.537h-11.233Zm10.951,20.029a8.31,8.31,0,0,0,5.917-2.066,8.2,8.2,0,0,0,0-11.2,8.31,8.31,0,0,0-5.917-2.066h-5.228v15.331Z",
    transform: "translate(-1681.705 -245.484)",
    fill: "#1a1a1a"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "pad",
    transform: "translate(249.126 90.671)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20928",
    "data-name": "Group 20928",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20927",
    "data-name": "Group 20927"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44326",
    "data-name": "Path 44326",
    d: "M2399.383,248.169a8.521,8.521,0,0,1,0,12.417,11.228,11.228,0,0,1-7.418,2.243h-6.641v7.807h-2.614V245.908h9.255A11.172,11.172,0,0,1,2399.383,248.169Zm-1.873,10.756a5.562,5.562,0,0,0,1.943-4.539,5.645,5.645,0,0,0-1.943-4.61,8.608,8.608,0,0,0-5.616-1.607h-6.57v12.364h6.57A8.605,8.605,0,0,0,2397.511,258.925Z",
    transform: "translate(-2382.71 -245.908)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44327",
    "data-name": "Path 44327",
    d: "M2809.439,264.03h-13.777l-2.967,6.606h-2.72l11.3-24.727h2.579l11.3,24.727h-2.755Zm-.954-2.119-5.935-13.282-5.935,13.282Z",
    transform: "translate(-2770.158 -245.908)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44328",
    "data-name": "Path 44328",
    d: "M3411.254,245.908h10.068a14.716,14.716,0,0,1,6.924,1.572,11.474,11.474,0,0,1,4.663,4.38,13.21,13.21,0,0,1,0,12.823,11.472,11.472,0,0,1-4.663,4.38,14.711,14.711,0,0,1-6.924,1.572h-10.068Zm9.926,22.466a11.986,11.986,0,0,0,5.687-1.289,9.365,9.365,0,0,0,3.78-3.568,10.92,10.92,0,0,0,0-10.491,9.369,9.369,0,0,0-3.78-3.568,11.992,11.992,0,0,0-5.687-1.289h-7.312v20.206Z",
    transform: "translate(-3361.207 -245.908)",
    fill: "#1a1a1a"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "light_purple",
    "data-name": "light purple",
    transform: "translate(349.363 92.883)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20932",
    "data-name": "Group 20932",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20931",
    "data-name": "Group 20931"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20930",
    "data-name": "Group 20930"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20929",
    "data-name": "Group 20929"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9073",
    "data-name": "Rectangle 9073",
    width: 14.357,
    height: 14.357,
    transform: "translate(0 10.152) rotate(-45)",
    fill: "#b195dd"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "medium_purple",
    "data-name": "medium purple",
    transform: "translate(339.211 82.731)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20936",
    "data-name": "Group 20936",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20935",
    "data-name": "Group 20935"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20934",
    "data-name": "Group 20934"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20933",
    "data-name": "Group 20933"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9074",
    "data-name": "Rectangle 9074",
    width: 14.357,
    height: 14.357,
    transform: "translate(0 30.455) rotate(-45)",
    fill: "#9778d2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9075",
    "data-name": "Rectangle 9075",
    width: 14.357,
    height: 14.357,
    transform: "translate(0 10.152) rotate(-45)",
    fill: "#9778d2"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "purple",
    transform: "translate(329.059 82.731)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20940",
    "data-name": "Group 20940",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20939",
    "data-name": "Group 20939"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20938",
    "data-name": "Group 20938"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20937",
    "data-name": "Group 20937"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44329",
    "data-name": "Path 44329",
    d: "M4025.463,718.786h20.3l-10.152-10.152Z",
    transform: "translate(-4025.463 -678.179)",
    fill: "#735ac7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44330",
    "data-name": "Path 44330",
    d: "M4025.463,82.732l10.152,10.152,10.152-10.152Z",
    transform: "translate(-4025.463 -82.732)",
    fill: "#735ac7"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "deep_purple",
    "data-name": "deep purple",
    transform: "translate(329.059 92.883)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20944",
    "data-name": "Group 20944",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20943",
    "data-name": "Group 20943"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20942",
    "data-name": "Group 20942"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20941",
    "data-name": "Group 20941"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9076",
    "data-name": "Rectangle 9076",
    width: 14.357,
    height: 14.357,
    transform: "translate(0 10.152) rotate(-45)",
    fill: "#4a3893"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendpadLoginLogo32C527Ca);
export default __webpack_public_path__ + "static/media/sendpad-login-logo.32c527ca.057adfe028c190db7280ea0e6f2bf8bf.svg";
export { ForwardRef as ReactComponent };